import { NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { connect } from 'react-redux';

import { ErrorDisplay } from './ErrorDisplay';
import { ErrorSource } from '../service/logger/ILoggerService';

import CoreContainer from 'core/components/CoreContainer';
import initialState from "core/reducers/initialState";
import EditorWrapper from './editor/EditorWrapper';
import  IdleStateHandler  from './IdleStateHandler';
import ReactGA from "react-ga4";
import ResourceLoader from 'core/util/resource/ResourceLoader';
import CookieSettings from './CookieSettings';

interface IAppProps {
	layout: string[];
	loading: boolean;
	startupError: string | null;
	editingEnabled: boolean;
	ga4MembershipId: string;
	metaTags:string;
	cookieExpiresAfter: string;
}

class App extends React.Component<IAppProps> {

	public render() {

		if(this.props.loading) {
			return null; // let the app loader take care of displaying progress now
		}

		if (this.props.startupError) {
			return (
				<ErrorDisplay
					type={ErrorSource.APP}
					location="root"
					error={{ message: this.props.startupError, info: null, errorCode: 'CNFG_LOAD_FLD' }}
				/>
			);
		}

		if(this.props.ga4MembershipId){
			ReactGA.initialize(this.props.ga4MembershipId);
		}

		if (this.props.metaTags) {
			ResourceLoader.loadMetaTags(this.props.metaTags)
		}

		if(this.props.editingEnabled) {
			if (!this.props.layout) {
				return (
					<NonIdealState
						icon={IconNames.WRENCH}
						title="Setup Required"
						description="Add config/layout to context settings."
					/>
				);
			}

			return (
				<EditorWrapper>
					<IdleStateHandler />
					<CoreContainer children={this.props.layout} />
					<CookieSettings expiry={this.props.cookieExpiresAfter} />
				</EditorWrapper>
			);
		}

		if (!this.props.layout) {
			return null;
		}

		return <React.Fragment>
					<IdleStateHandler />
					<CoreContainer children={this.props.layout} />
					<CookieSettings expiry={this.props.cookieExpiresAfter} />
			   </React.Fragment>;
	}
}

const mapStateToProps = (state: typeof initialState): IAppProps => {
	return {
		layout: state.layout,
		loading: !state.initialization.done,
		startupError: state.initialization.startupError,
		editingEnabled: state.edit.enabled,
		ga4MembershipId:state.config.contextProperties["app.analytics.ga4.key"],
		cookieExpiresAfter:state.config.contextProperties["ui.cookieExpiresAt"] || 30, // in days
		metaTags: state.config.contextProperties["app.metaTages"]
	};
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/core/components/App.tsx